const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/drilling-machines`,
    saveSpeedTable: `${API_URL}/drilling-machine/save-speed-table`
};

export default apiUrls;
